/**
 * useEffect deep compare
 */
import { useEffect, useRef } from 'react';
import _ from 'lodash';

const useDeepEffect = (callback, deps, needInit = false) => {
  const isFirst = useRef(true);
  const prevDeps = useRef(deps);

  useEffect(() => {
    const isSame = prevDeps.current.every((obj, index) => _.isEqual(obj, deps[index]));
    if ((needInit && isFirst.current) || !isSame) {
      callback();
    }
    isFirst.current = false;
    prevDeps.current = deps;
  }, deps);
};

export default useDeepEffect;
